/* =====================================================================
   RYNOR – "Build a bundle & save" on the product page
   snippets/bundle-upsell.liquid (block "Bundle upsell" in main-product)
   - 1 piece / 3 pieces / 7 pieces. Picking a bundle fills it at random
     around the product on the page ("This one"), like the bundle page's
     Shuffle. The fill picks pieces priced like "This one" or higher, so the
     bundle always shows a clear saving; cheaper pieces can still be swapped
     in. Savings shown are real: the pieces' prices minus the bundle.
   - Tap a piece to swap it: "Choose a piece" pop-out with the bundle
     page's tabs, filters, size pop-up and ring size guide.
   - Adds the bundle product as ONE cart line with the same properties as
     the bundle page (Piece 1… / _p1… / _bundle / _bundle_count).
   - The sticky bar (assets/sticky-product-bar.js) asks this element for
     its label and hands its click over while a bundle is picked.
   No dependencies.
   ===================================================================== */
(function () {
  'use strict';

  if (!window.customElements || window.customElements.get('rynor-bundle-upsell')) return;

  var MAX_PAGES = 6;   /* "Choose a piece": up to 6 × 50 pieces per tab */
  var CLEAR_SAVE = 0.2; /* the random fill aims to save at least 20% of the bundle price (and $3) on every bundle */

  /* ---------------- helpers (same as assets/rynor-bundle.js) ---------------- */
  function toArray(list) { return Array.prototype.slice.call(list || []); }
  function noop() {}

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* strings from Liquid use [[name]] placeholders (curly braces break Liquid) */
  function tpl(str, vars) {
    return String(str || '').replace(/\[\[(\w+)\]\]/g, function (m, key) {
      return vars && vars[key] != null ? vars[key] : m;
    });
  }

  /* Shopify's t filter HTML-escapes translations (Don't -> Don&#39;t) */
  var entityBox = document.createElement('textarea');
  function decodeEntities(str) {
    if (typeof str !== 'string' || str.indexOf('&') < 0) return str;
    entityBox.innerHTML = str;
    return entityBox.value;
  }
  function decodeAll(obj) {
    obj = obj || {};
    Object.keys(obj).forEach(function (k) {
      var v = obj[k];
      obj[k] = Array.isArray(v) ? v.map(decodeEntities) : decodeEntities(v);
    });
    return obj;
  }

  function parseChart(raw) {
    var out = [];
    String(raw || '').split(/[\n;]+/).forEach(function (line) {
      var m = line.match(/^\s*([^=]+?)\s*=\s*([\d.,]+)\s*$/);
      if (!m) return;
      var c = parseFloat(m[2].replace(',', '.'));
      if (c > 0) out.push({ size: m[1].trim(), c: c });
    });
    return out.sort(function (a, b) { return a.c - b.c; });
  }

  function imgSize(url, width) {
    if (!url) return '';
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + width);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function shuffled(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function mq(query) { return window.matchMedia ? window.matchMedia(query) : { matches: false }; }
  var reduceMotion = mq('(prefers-reduced-motion: reduce)').matches;
  var hoverMq = mq('(hover: hover) and (pointer: fine)');

  function MoneyFormatter(sample) {
    var m = String(sample || '$1,234,567.89').match(/^(.*?)([\d.,\s ']*\d)(.*)$/);
    var prefix = m ? m[1] : '', run = m ? m[2] : '1,234,567.89', suffix = m ? m[3] : '';
    var digits = run.replace(/\D/g, '');
    var decimals = 0, decSep = '.', thouSep = ',';
    if (digits.slice(-2) === '89' && digits.length === 9) { decimals = 2; decSep = run.charAt(run.length - 3); }
    else if (digits.slice(-1) === '9' && digits.length === 8) { decimals = 1; decSep = run.charAt(run.length - 2); }
    var intPart = decimals ? run.slice(0, run.length - decimals - 1) : run;
    var sepMatch = intPart.match(/\D/);
    thouSep = sepMatch ? sepMatch[0] : '';
    function group(n) {
      var s = String(n), out = '';
      while (s.length > 3) { out = thouSep + s.slice(-3) + out; s = s.slice(0, -3); }
      return s + out;
    }
    this.format = function (cents, trimZeros) {
      cents = Math.round(Number(cents) || 0);
      var neg = cents < 0; if (neg) cents = -cents;
      var units = Math.floor(cents / 100), rem = cents % 100, out = group(units);
      if (decimals === 2 && !(trimZeros && rem === 0)) out += decSep + (rem < 10 ? '0' + rem : String(rem));
      else if (decimals === 1 && !(trimZeros && rem === 0)) out += decSep + String(Math.round(rem / 10));
      return (neg ? '-' : '') + prefix + out + suffix;
    };
  }

  /* ---------------- theme cart pop-out (WAU.AjaxCart, same as the bundle page) ---------------- */
  function themeCartConfig() {
    try {
      var el = document.getElementById('cart-config');
      if (el && el.textContent) return JSON.parse(el.textContent);
    } catch (e) {}
    return { cart_action: 'drawer' };
  }

  function hasThemeCart() {
    return !!(window.WAU && window.WAU.AjaxCart &&
      (typeof window.WAU.AjaxCart.showDrawer === 'function' || typeof window.WAU.AjaxCart.showModal === 'function'));
  }

  function openThemeCart() {
    var W = window.WAU;
    var tc = themeCartConfig();
    var step = Promise.resolve();
    try {
      if (W.ThemeCart && typeof W.ThemeCart.getCart === 'function' && typeof W.AjaxCart.updateView === 'function') {
        step = W.ThemeCart.getCart().then(function (cart) { return W.AjaxCart.updateView(tc, cart); });
      }
    } catch (e) {}
    return step.catch(noop).then(function () {
      try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
      try {
        if (tc.cart_action === 'modal_cart' && typeof W.AjaxCart.showModal === 'function') W.AjaxCart.showModal(tc);
        else if (typeof W.AjaxCart.showDrawer === 'function') W.AjaxCart.showDrawer(Object.assign({}, tc, { cart_action: 'drawer' }));
      } catch (e) {}
    });
  }

  /* ---------------- product normalisation (same as the bundle page) ---------------- */
  var SIZE_WORDS = ['size', 'ring', 'accessory', 'talla', 'taille', 'größe', 'groesse', 'grösse', 'taglia', 'maat', 'length', 'longitud', 'longueur', 'länge', 'lunghezza', 'lengte'];
  var SILVER = ['silver', 'plata', 'argent', 'silber', 'zilver', 'argento', 'steel', 'stainless', 'white'];
  var GOLD = ['gold', 'oro', 'or ', 'goud', 'golden', 'dorado', 'doré', 'dore', '18k', '14k'];

  function metalOf(value) {
    var v = ' ' + String(value || '').toLowerCase() + ' ';
    var i;
    for (i = 0; i < GOLD.length; i++) if (v.indexOf(GOLD[i]) > -1) return 'gold';
    for (i = 0; i < SILVER.length; i++) if (v.indexOf(SILVER[i]) > -1) return 'silver';
    return null;
  }

  function normalizeProduct(raw) {
    var names = (raw.o || []).map(function (n) { return String(n || '').toLowerCase(); });
    var vs = raw.v || [];
    var sizeIdx = -1, metalIdx = -1, i, j;

    for (i = 0; i < names.length && sizeIdx < 0; i++) {
      for (j = 0; j < SIZE_WORDS.length; j++) {
        if (names[i].indexOf(SIZE_WORDS[j]) > -1) { sizeIdx = i; break; }
      }
    }
    for (i = 0; i < names.length && metalIdx < 0; i++) {
      if (i === sizeIdx) continue;
      var hits = 0;
      for (j = 0; j < vs.length; j++) if (metalOf(vs[j].o[i])) hits++;
      if (vs.length && hits >= vs.length / 2) metalIdx = i;
    }
    if (sizeIdx < 0) {
      for (i = 0; i < names.length; i++) {
        if (i === metalIdx) continue;
        var seen = {}, count = 0;
        for (j = 0; j < vs.length; j++) { var val = vs[j].o[i]; if (!seen[val]) { seen[val] = 1; count++; } }
        if (count > 1) { sizeIdx = i; break; }
      }
    }

    var variants = vs.map(function (v) {
      return {
        id: v.id, price: Number(v.p) || 0, available: !!v.a, sku: v.k || '', image: v.i || null,
        size: sizeIdx > -1 ? String(v.o[sizeIdx]) : null,
        metal: metalIdx > -1 ? metalOf(v.o[metalIdx]) : null,
        metalValue: metalIdx > -1 ? String(v.o[metalIdx]) : null
      };
    });
    var metals = {};
    variants.forEach(function (v) { if (v.metal) metals[v.metal] = true; });

    return {
      id: raw.id, handle: raw.h, title: raw.t, url: raw.u,
      tags: (raw.tg || []).map(function (t) { return String(t).toLowerCase(); }),
      available: !!raw.a, ts: raw.ts || '', gc: !!raw.gc, images: raw.im || [],
      variants: variants, hasSize: sizeIdx > -1, hasMetal: metalIdx > -1, metals: metals, cat: null
    };
  }

  function variantsFor(product, metal) {
    if (!product.hasMetal || !metal) return product.variants;
    return product.variants.filter(function (v) { return v.metal === metal; });
  }

  function sizeRange(variants) {
    var sizes = [];
    variants.forEach(function (v) { if (v.size && sizes.indexOf(v.size) < 0) sizes.push(v.size); });
    return sizes;
  }

  function lowestPrice(variants) {
    var p = null;
    variants.forEach(function (v) { if (p === null || v.price < p) p = v.price; });
    return p || 0;
  }

  function imagesFor(product, metal) {
    var list = variantsFor(product, metal);
    var first = null, i;
    for (i = 0; i < list.length; i++) if (list[i].image) { first = list[i].image; break; }
    if (!first) first = product.images[0] || '';
    var other = {};
    if (product.hasMetal && metal) {
      product.variants.forEach(function (v) { if (v.metal && v.metal !== metal && v.image) other[v.image.split('?')[0]] = 1; });
    }
    var second = '';
    var base = first.split('?')[0];
    for (i = 0; i < product.images.length; i++) {
      var im = product.images[i], key = im.split('?')[0];
      if (key !== base && !other[key]) { second = im; break; }
    }
    return [first, second];
  }

  function avail(v) { return v.available; }
  function same(a, b) { return String(a) === String(b); }
  function clone(o) { return JSON.parse(JSON.stringify(o)); }

  var PENCIL = '<svg width="11" height="11" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 20h4L19 9l-4-4L4 16v4z" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round"/><path d="M13.5 6.5l4 4" stroke="currentColor" stroke-width="2.2"/></svg>';
  var PLUS = '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M6 1v10M1 6h10" stroke="currentColor" stroke-width="1.8"/></svg>';

  /* ------------------------------------------------------------------ */
  /* element                                                            */
  /* ------------------------------------------------------------------ */
  function RynorBundleUpsell() { return Reflect.construct(HTMLElement, [], RynorBundleUpsell); }
  RynorBundleUpsell.prototype = Object.create(HTMLElement.prototype);
  RynorBundleUpsell.prototype.constructor = RynorBundleUpsell;
  Object.setPrototypeOf(RynorBundleUpsell, HTMLElement);
  var proto = RynorBundleUpsell.prototype;

  proto.q = function (sel) { return this.querySelector(sel); };
  proto.lq = function (sel) { return (this.layer || this).querySelector(sel); };

  proto.connectedCallback = function () {
    if (this._ready) {
      if (this.layer && this.layer.parentNode !== document.body) document.body.appendChild(this.layer);
      this.bindGlobal();
      return;
    }
    var cfgEl = this.q('[data-rbu-config]');
    if (!cfgEl) return;
    try { this.cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.error('[rynor-bundle-upsell] bad config', e); return; }
    this._ready = true;

    var cfg = this.cfg;
    this.i18n = decodeAll(cfg.i18n);
    this.money = new MoneyFormatter(cfg.moneySample);
    this.priceCut = !!cfg.priceCut; /* block setting: red price + crossed-out full price, no .00 */
    this.chips = !!cfg.chips; /* block setting Button style = B11 chips: "3 for $75", no .00 */
    this.tiers = (cfg.tiers || []).filter(function (t) { return t && t.n > 0; });
    this.maxN = 1;
    var i;
    for (i = 0; i < this.tiers.length; i++) this.maxN = Math.max(this.maxN, this.tiers[i].n);
    this.picks = [];
    for (i = 0; i < this.maxN; i++) this.picks.push(null);
    this.tier = 0;
    this.byId = {};
    this.products = {};
    this.self = normalizeProduct(cfg.self || {});
    this.self.cat = typeof cfg.selfCat === 'number' ? cfg.selfCat : -1;
    this.byId[this.self.id] = this.self;
    this.metal = cfg.defaultMetal || 'silver';
    this.cat = 0;
    this.sub = '';
    this.pickSlot = -1;
    this.openMenu = -1;
    this.newSlot = -1;
    this.modalStack = [];
    this.pickerOpen = false;
    this.busy = false;
    this.generated = false;

    this.root = this.closest('[data-section-type="product"]') || this.closest('.product-page') || document;
    this.info = this.closest('.cc-product-info') || this.parentNode;

    /* pop-outs live on <body> so sticky columns / transforms on the page can't trap them */
    this.layer = this.q('[data-rbu-layer]');
    if (this.layer) document.body.appendChild(this.layer);

    this.el = {
      tiers: toArray(this.querySelectorAll('[data-tier]')),
      tierGroup: this.q('[data-tiers]'),
      panel: this.q('[data-panel]'),
      slots: this.q('[data-slots]'),
      count: this.q('[data-count]'),
      retail: this.q('[data-retail]'),
      price: this.q('[data-price]'),
      pp: this.q('[data-pp]'),
      save: this.q('[data-save]'),
      buy: this.q('[data-buy]'),
      cta: this.q('[data-cta]'),
      msg: this.q('[data-msg]'),
      live: this.q('[data-live]'),
      shuffle: this.q('[data-shuffle]'),
      picker: this.lq('[data-picker]'),
      body: this.lq('[data-picker-body]'),
      grid: this.lq('[data-grid]'),
      status: this.lq('[data-status]'),
      meta: this.lq('[data-meta]'),
      cats: this.lq('[data-cats]'),
      subs: this.lq('[data-subs]'),
      metalToggle: this.lq('[data-metal-toggle]'),
      size: this.lq('[data-modal="size"]'),
      guide: this.lq('[data-modal="guide"]'),
      dupes: this.lq('[data-modal="dupes"]')
    };

    this.bind();
    this.initGuide();
    this.syncSelf(true);
    this.watch();
  };

  proto.disconnectedCallback = function () {
    this.unbindGlobal();
    if (this._io) { this._io.disconnect(); this._io = null; }
    if (this.layer && this.layer.parentNode === document.body) document.body.removeChild(this.layer);
    if (this.info && this.info.classList) this.info.classList.remove('rbu-on');
    document.body.classList.remove('rbu-lock');
  };

  /* ---------------- events ---------------- */
  proto.bind = function () {
    var self = this;
    var el = this.el;

    el.tiers.forEach(function (b) {
      b.addEventListener('click', function () { self.setTier(parseInt(b.getAttribute('data-tier'), 10)); });
    });
    if (el.tierGroup) el.tierGroup.addEventListener('keydown', function (e) { self.tierKeys(e); });

    /* load the pieces as soon as someone shows interest */
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) {
      self.addEventListener(ev, function () { self.warm(); }, { passive: true, once: true });
    });

    if (el.slots) {
      el.slots.addEventListener('click', function (e) {
        var b = e.target.closest('[data-act]');
        if (!b || !el.slots.contains(b)) return;
        e.stopPropagation();
        var i = parseInt(b.getAttribute('data-idx'), 10);
        var act = b.getAttribute('data-act');
        if (act === 'swap') self.openPicker(i, b);
        else if (act === 'menu') self.toggleMenu(i);
        else if (act === 'size') { self.closeMenus(true); self.openSizeFor(i, b); }
      });
    }
    if (el.shuffle) el.shuffle.addEventListener('click', function () { self.shuffle(); });
    if (el.cta) el.cta.addEventListener('click', function () { self.checkout(el.cta); });

    if (this.layer) {
      toArray(this.layer.querySelectorAll('[data-picker-close]')).forEach(function (b) {
        b.addEventListener('click', function () { self.closePicker(); });
      });
    }

    if (el.cats) {
      var cats = this.cfg.categories || [];
      el.cats.innerHTML = cats.map(function (c, i) {
        return '<button type="button" role="tab" class="rbu-cat" data-cat="' + i + '" aria-selected="false" tabindex="-1">' + esc(c.label) + '</button>';
      }).join('');
      el.cats.addEventListener('click', function (e) {
        var b = e.target.closest('[data-cat]');
        if (b) self.selectCategory(parseInt(b.getAttribute('data-cat'), 10));
      });
      el.cats.addEventListener('keydown', function (e) { self.tabKeys(e, el.cats, '[data-cat]'); });
    }
    if (el.subs) {
      el.subs.addEventListener('click', function (e) {
        var b = e.target.closest('[data-sub]');
        if (b) self.selectSub(b.getAttribute('data-sub'));
      });
      el.subs.addEventListener('keydown', function (e) { self.tabKeys(e, el.subs, '[data-sub]'); });
    }
    if (el.metalToggle) {
      el.metalToggle.addEventListener('click', function (e) {
        var b = e.target.closest('[data-metal]');
        if (!b || b.getAttribute('data-metal') === self.metal) return;
        self.metal = b.getAttribute('data-metal');
        self.syncMetalButtons();
        self.renderGrid();
      });
    }
    if (el.grid) {
      el.grid.addEventListener('click', function (e) {
        var b = e.target.closest('[data-pick]');
        if (!b || b.disabled) return;
        var card = b.closest('[data-pid]');
        if (card && !card.classList.contains('is-soldout')) self.choosePiece(card.getAttribute('data-pid'), b);
      });
      el.grid.addEventListener('scroll', function (e) {
        var t = e.target;
        if (!t.classList || !t.classList.contains('rbu-card__track')) return;
        var dots = t.parentNode.querySelectorAll('.rbu-card__dots i');
        if (!dots.length) return;
        var idx = Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
        toArray(dots).forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
      }, true);
      el.grid.addEventListener('mouseover', function (e) { self.hoverSwap(e, true); });
      el.grid.addEventListener('mouseout', function (e) { self.hoverSwap(e, false); });
    }

    if (this.layer) {
      toArray(this.layer.querySelectorAll('[data-modal]')).forEach(function (m) {
        toArray(m.querySelectorAll('[data-close]')).forEach(function (b) {
          b.addEventListener('click', function () { self.closeModal(m); });
        });
      });
    }
    if (el.size) {
      var sizes = el.size.querySelector('[data-szp-sizes]');
      if (sizes) {
        sizes.addEventListener('click', function (e) {
          var b = e.target.closest('[data-size-vid]');
          if (b && !b.disabled) self.chooseSize(b.getAttribute('data-size-vid'));
        });
        sizes.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter') return;
          var b = e.target.closest('[data-size-vid]');
          if (b && !b.disabled) { e.preventDefault(); self.chooseSize(b.getAttribute('data-size-vid')); self.saveSize(); }
        });
      }
      var save = el.size.querySelector('[data-szp-save]');
      if (save) save.addEventListener('click', function () { self.saveSize(); });
      var guideBtn = el.size.querySelector('[data-szp-guide]');
      if (guideBtn) guideBtn.addEventListener('click', function () { self.openGuide(guideBtn); });
    }
    if (el.dupes) {
      var change = el.dupes.querySelector('[data-dupe-change]');
      var go = el.dupes.querySelector('[data-dupe-continue]');
      if (change) change.addEventListener('click', function () { self._pending = null; self.closeModal(el.dupes); });
      if (go) go.addEventListener('click', function () {
        var trigger = self._pending;
        self._pending = null;
        self.closeModal(el.dupes);
        self.addToCart(trigger);
      });
    }

    this.bindGlobal();
  };

  proto.bindGlobal = function () {
    if (this._globalBound) return;
    this._globalBound = true;
    var self = this;
    this._onDocClick = function (e) {
      if (self.openMenu > -1 && !(e.target.closest && e.target.closest('.rbu-slot'))) self.closeMenus();
    };
    this._onKey = function (e) {
      var top = self.modalStack[self.modalStack.length - 1];
      if (e.key === 'Escape') {
        if (top) { self.closeModal(top); return; }
        if (self.pickerOpen) { self.closePicker(); return; }
        if (self.openMenu > -1) self.closeMenus();
        return;
      }
      if (e.key === 'Tab') {
        var box = top ? top.querySelector('.rbu-modal__panel') : (self.pickerOpen && self.el.picker ? self.el.picker.querySelector('.rbu-picker__panel') : null);
        if (box) self.trapFocus(e, box);
      }
    };
    this._onVariant = function () { self.syncSelf(false); };
    document.addEventListener('click', this._onDocClick);
    document.addEventListener('keydown', this._onKey);
    this._variantInput = this.variantInput();
    if (this._variantInput) this._variantInput.addEventListener('change', this._onVariant);
  };

  proto.unbindGlobal = function () {
    if (!this._globalBound) return;
    this._globalBound = false;
    document.removeEventListener('click', this._onDocClick);
    document.removeEventListener('keydown', this._onKey);
    if (this._variantInput) this._variantInput.removeEventListener('change', this._onVariant);
  };

  proto.tabKeys = function (e, box, sel) {
    var keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
    if (keys.indexOf(e.key) < 0) return;
    var tabs = toArray(box.querySelectorAll(sel));
    var i = tabs.indexOf(document.activeElement);
    if (i < 0) return;
    e.preventDefault();
    var next = e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    tabs[next].focus();
    tabs[next].click();
  };

  proto.tierKeys = function (e) {
    var keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
    if (keys.indexOf(e.key) < 0) return;
    e.preventDefault();
    var dir = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1;
    var n = this.el.tiers.length;
    for (var k = 1; k < n; k++) {
      var b = this.el.tiers[(this.tier + dir * k + n * 2) % n];
      if (b && !b.disabled) {
        this.setTier(parseInt(b.getAttribute('data-tier'), 10));
        b.focus();
        return;
      }
    }
  };

  /* ---------------- the product on the page ("This one") ---------------- */
  proto.variantInput = function () {
    var r = this.root || document;
    return r.querySelector('form[id^="product-form-buttons-"] input[name="id"]') || r.querySelector('#formVariantId');
  };

  proto.currentVariantId = function () {
    var input = this._variantInput || this.variantInput();
    return String((input && input.value) || this.cfg.variantId || '');
  };

  proto.selfSize = function () {
    return this.self.hasSize && this.selfVariant ? this.selfVariant.size : null;
  };

  proto.prefMetal = function () {
    return (this.selfVariant && this.selfVariant.metal) || null;
  };

  proto.pieceFrom = function (p, v) {
    return {
      pid: p.id, handle: p.handle, title: p.title, url: p.url,
      vid: v.id, sku: v.sku || '', size: v.size, metal: v.metalValue, metalKey: v.metal,
      price: v.price, img: v.image || imagesFor(p, v.metal || this.metal)[0] || '',
      cat: p.cat, needsSize: false, inherit: false, self: false, user: false
    };
  };

  proto.selfPiece = function () {
    var v = this.selfVariant || this.self.variants[0];
    if (!v) return null;
    var piece = this.pieceFrom(this.self, v);
    piece.self = true;
    piece.cat = this.self.cat;
    return piece;
  };

  proto.syncSelf = function (initial) {
    var vid = this.currentVariantId();
    var v = null;
    this.self.variants.forEach(function (x) { if (same(x.id, vid)) v = x; });
    if (!v) v = this.self.variants.filter(avail)[0] || this.self.variants[0] || null;
    var changed = !initial && v && this.selfVariant && !same(v.id, this.selfVariant.id);
    this.selfVariant = v;
    var i;
    for (i = 0; i < this.picks.length; i++) if (this.picks[i] && this.picks[i].self) this.picks[i] = this.selfPiece();
    if (initial && !this.picks[0]) this.picks[0] = this.selfPiece();
    if (changed) {
      /* pieces that copied this ring's size follow it */
      for (i = 0; i < this.picks.length; i++) if (this.picks[i] && this.picks[i].inherit) this.reinherit(i);
    }
    if (this.tier > 0 && !this.tierOk(this.tier)) this.setTier(0, true);
    this.renderTiers();
    this.renderPanel();
    this.emit();
  };

  proto.reinherit = function (i) {
    var s = this.picks[i];
    var p = s && this.byId[s.pid];
    if (!p) return;
    var want = this.selfSize();
    var all = variantsFor(p, s.metalKey || null);
    var list = all.filter(avail);
    var match = null;
    if (want != null) list.forEach(function (v) { if (!match && String(v.size) === String(want)) match = v; });
    if (match) {
      s.vid = match.id; s.sku = match.sku || ''; s.size = match.size; s.price = match.price; s.needsSize = false;
      if (match.image) s.img = match.image;
    } else {
      s.size = null; s.needsSize = true; s.inherit = false; s.price = lowestPrice(list.length ? list : all);
    }
  };

  /* ---------------- loading the pieces ---------------- */
  proto.watch = function () {
    var self = this;
    var conn = navigator.connection || {};
    if (conn.saveData) return;
    if (!('IntersectionObserver' in window)) { setTimeout(function () { self.warm(); }, 2500); return; }
    this._io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting || !self._io) return;
        self._io.disconnect();
        self._io = null;
        var go = function () { self.warm(); };
        if (window.requestIdleCallback) window.requestIdleCallback(go, { timeout: 2500 });
        else setTimeout(go, 1200);
      });
    }, { rootMargin: '300px 0px' });
    this._io.observe(this);
  };

  proto.warm = function () {
    var self = this;
    if (this._warmP) return this._warmP;
    var cats = this.cfg.categories || [];
    this._warmP = Promise.all(cats.map(function (c, i) {
      return self.ensureCategory(i).catch(function () { return null; });
    })).then(function () {
      var failed = !cats.some(function (c, i) { return self.products[i] && self.products[i].first; });
      if (failed) {
        self._warmP = null;
        if (self.tier > 0) self.flash(self.i18n.loadError, 'error');
      }
      if (!self.generated && !failed) self.generate(false);
      self.renderTiers();
      self.renderPanel();
      self.emit();
    });
    return this._warmP;
  };

  proto.loadPage = function (feed, page) {
    var url = feed + (feed.indexOf('?') > -1 ? '&' : '?') + 'page=' + page;
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var node = doc.querySelector('[data-bundle-feed]');
      if (!node) throw new Error('feed missing');
      return JSON.parse(node.textContent);
    });
  };

  proto.ensureCategory = function (index) {
    var self = this;
    var cat = (this.cfg.categories || [])[index];
    if (!cat) return Promise.reject(new Error('no category'));
    var entry = this.products[index];
    if (entry && entry.promise) return entry.promise;
    entry = this.products[index] = { list: [], first: false, done: false, pages: 1, rest: false };
    entry.promise = this.loadPage(cat.feed, 1).then(function (data) {
      self.ingest(index, data.products);
      entry.first = true;
      entry.pages = Math.min(Number(data.pages) || 1, MAX_PAGES);
      if (entry.pages < 2) entry.done = true;
      return entry;
    });
    entry.promise.catch(function () { if (self.products[index] === entry) delete self.products[index]; });
    return entry.promise;
  };

  proto.loadRest = function (index) {
    var self = this;
    var entry = this.products[index];
    var cat = (this.cfg.categories || [])[index];
    if (!entry || !entry.first || entry.done || entry.rest || !cat) return;
    entry.rest = true;
    var chain = Promise.resolve();
    for (var p = 2; p <= entry.pages; p++) {
      (function (page) {
        chain = chain.then(function () {
          return self.loadPage(cat.feed, page).then(function (data) {
            var added = self.ingest(index, data.products);
            if (self.pickerOpen && self.cat === index && added.length) { self.renderSubs(); self.renderGrid(); }
          });
        });
      })(p);
    }
    chain.catch(noop).then(function () {
      entry.done = true;
      if (self.pickerOpen && self.cat === index) self.renderMeta();
    });
  };

  proto.ingest = function (index, rawList) {
    var entry = this.products[index];
    var self = this;
    var added = [];
    (rawList || []).forEach(function (raw) {
      if (!raw || !raw.v || !raw.v.length) return;
      var p = self.byId[raw.id] || normalizeProduct(raw);
      if (p.cat === null || p.cat === undefined || p.cat < 0) p.cat = index;
      self.byId[p.id] = p;
      if (entry && !entry.list.some(function (x) { return same(x.id, p.id); })) { entry.list.push(p); added.push(p); }
    });
    return added;
  };

  proto.isPiece = function (p) {
    if (!p || p.gc) return false;
    if (p.ts && /bundle/i.test(p.ts)) return false;
    return !this.tiers.some(function (t) { return t.id && same(t.id, p.id); });
  };

  proto.eligible = function (p) {
    return this.isPiece(p) && p.available && p.variants.some(avail);
  };

  /* ---------------- random fill ---------------- */
  /* a ready-to-buy piece for the random fill: same metal as this one, and for rings this ring's size
     when the piece has it. Other sized pieces wait for the shopper to pick ("Select size"). */
  proto.autoPiece = function (p) {
    var metal = this.prefMetal() || this.metal;
    var all = variantsFor(p, metal);
    if (!all.some(avail) && p.hasMetal) { metal = metal === 'gold' ? 'silver' : 'gold'; all = variantsFor(p, metal); }
    if (!all.some(avail)) all = p.variants;
    var list = all.filter(avail);
    if (!list.length) return null;
    if (p.hasSize && sizeRange(all).length > 1) {
      var want = this.selfSize();
      var match = null;
      if (want != null) list.forEach(function (v) { if (!match && String(v.size) === String(want)) match = v; });
      if (match) {
        var inh = this.pieceFrom(p, match);
        inh.inherit = true;
        return inh;
      }
      var piece = this.pieceFrom(p, list[0]);
      piece.size = null;
      piece.needsSize = true;
      piece.price = lowestPrice(list);
      return piece;
    }
    return this.pieceFrom(p, list[0]);
  };

  /* the smallest bundle (3 pieces): its pieces come from different tabs */
  proto.firstN = function () {
    var n = this.maxN;
    this.tiers.forEach(function (t) { if (t.n > 1 && t.n < n) n = t.n; });
    return n;
  };

  /* every piece that can go in without asking the shopper anything: one size, or this ring's size */
  proto.readyPool = function () {
    var self = this;
    var seen = {};
    seen[this.self.id] = true;
    return (this.cfg.categories || []).map(function (c, i) {
      var entry = self.products[i];
      var out = [];
      if (!entry) return out;
      entry.list.forEach(function (p) {
        if (seen[p.id] || !self.eligible(p)) return;
        var piece = self.autoPiece(p);
        if (!piece || piece.needsSize) return;
        seen[p.id] = true;
        piece.cat = i;
        out.push(piece);
      });
      return out;
    });
  };

  /* one random piece from the whole catalogue: a random tab (bigger tabs a bit more likely), then any
     piece in it. The 3-piece mixes different tabs; the 7-piece takes at most 2 from one tab.
     floor (cents): only pieces priced at least this much, while any tab still has one; the mix of
     tabs comes first, so when no open tab has a piece that pricey, any piece from an open tab. */
  proto.drawPiece = function (pool, used, count, avoid, first, floor) {
    var caps = first ? [1, 2, 99] : [2, 3, 99];
    var floors = floor > 0 ? [floor, 0] : [0];
    for (var c = 0; c < caps.length; c++) {
      for (var f = 0; f < floors.length; f++) {
        var min = floors[f];
        var opts = [], total = 0;
        for (var ci = 0; ci < pool.length; ci++) {
          if ((count[ci] || 0) >= caps[c]) continue;
          var cands = pool[ci].filter(function (x) {
            return !used[x.pid] && !(avoid && avoid[x.pid]) && !(min > 0 && (x.price || 0) < min);
          });
          if (!cands.length) continue;
          var w = Math.sqrt(cands.length);
          opts.push({ list: cands, w: w });
          total += w;
        }
        if (!opts.length) continue;
        var r = Math.random() * total;
        for (var k = 0; k < opts.length; k++) {
          r -= opts[k].w;
          if (r <= 0 || k === opts.length - 1) return clone(opts[k].list[Math.floor(Math.random() * opts[k].list.length)]);
        }
      }
    }
    return null;
  };

  /* last resort when the ready pieces run out: a piece that still needs a size */
  proto.drawSpare = function (used) {
    var self = this;
    var list = [];
    (this.cfg.categories || []).forEach(function (c, i) {
      var entry = self.products[i];
      if (!entry) return;
      entry.list.forEach(function (p) {
        if (used[p.id] || same(p.id, self.self.id) || !self.eligible(p)) return;
        var piece = self.autoPiece(p);
        if (piece) { piece.cat = i; list.push(piece); }
      });
    });
    return list.length ? clone(list[Math.floor(Math.random() * list.length)]) : null;
  };

  /* >= 0 when every bundle saves at least CLEAR_SAVE of its price (and $3) */
  proto.saveScore = function (picks) {
    var worst = Infinity;
    this.tiers.forEach(function (t) {
      if (!(t.n > 1)) return;
      var sum = 0;
      for (var i = 0; i < t.n; i++) sum += picks[i] ? picks[i].price : 0;
      worst = Math.min(worst, sum - t.price - Math.max(300, Math.round(t.price * CLEAR_SAVE)));
    });
    return worst === Infinity ? 0 : worst;
  };

  /* random mix around "This one" from every piece in every tab. The fill picks pieces priced like
     "This one" or higher (similar or pricier pieces), so every bundle shows a clear saving (CLEAR_SAVE);
     the shopper can still swap in any cheaper piece. A shuffle never brings back the pieces it replaces
     (while there are others). If no mix reaches CLEAR_SAVE, the one that saves the most is used. */
  proto.generate = function (reshuffle) {
    if (reshuffle || !this.picks[0]) this.picks[0] = this.selfPiece();
    var pool = this.readyPool();
    var firstN = this.firstN();
    var floor = this.picks[0] && this.picks[0].price > 0 ? this.picks[0].price : 0;
    var avoid = {};
    var s;
    if (reshuffle) for (s = 1; s < this.picks.length; s++) if (this.picks[s]) avoid[this.picks[s].pid] = true;
    var best = null, bestScore = -Infinity;
    for (var attempt = 0; attempt < 40; attempt++) {
      var out = this.picks.slice();
      var used = {}, count = {};
      used[this.self.id] = true;
      for (s = 0; s < out.length; s++) {
        var keep = out[s] && (s === 0 || (!reshuffle && out[s].user));
        if (!keep) { out[s] = null; continue; }
        used[out[s].pid] = true;
        if (out[s].cat != null && out[s].cat > -1) count[out[s].cat] = (count[out[s].cat] || 0) + 1;
      }
      var fresh = attempt < 30 ? avoid : null;
      for (s = 1; s < out.length; s++) {
        if (out[s]) continue;
        var first = s < firstN;
        var piece = this.drawPiece(pool, used, count, fresh, first, floor) || this.drawPiece(pool, used, count, null, first, floor) || this.drawSpare(used);
        out[s] = piece;
        if (!piece) continue;
        used[piece.pid] = true;
        count[piece.cat] = (count[piece.cat] || 0) + 1;
      }
      var score = this.saveScore(out);
      if (score > bestScore) { bestScore = score; best = out; }
      if (score >= 0) break;
    }
    if (best) this.picks = best;
    this.generated = true;
  };

  /* the rest of each tab (page 2+), so shuffles can use every piece */
  proto.loadMore = function () {
    var cats = this.cfg.categories || [];
    for (var i = 0; i < cats.length; i++) this.loadRest(i);
  };

  proto.shuffle = function () {
    if (!this.generated) { this.warm(); return; }
    this.loadMore();
    this.closeMenus(true);
    this.generate(true);
    this._popAll = true;
    this.renderPanel();
    this.renderTiers();
    this.emit();
    this.say(this.i18n.shuffled);
  };

  /* ---------------- 1 / 3 / 7 ---------------- */
  proto.tierOk = function (i) {
    var t = this.tiers[i];
    if (!t) return false;
    if (i === 0) return true;
    if (t.available === false) return false;
    var hasSelf = false;
    for (var k = 0; k < t.n && k < this.picks.length; k++) if (this.picks[k] && this.picks[k].self) hasSelf = true;
    return !(hasSelf && !(this.selfVariant && this.selfVariant.available));
  };

  proto.setTier = function (i, quiet) {
    if (isNaN(i) || !this.tiers[i] || i === this.tier) return;
    if (i > 0 && !this.tierOk(i)) return;
    this.tier = i;
    this.closeMenus(true);
    if (i > 0) {
      var self = this;
      this.warm().then(function () { self.loadMore(); });
    }
    this.renderTiers();
    this.renderPanel();
    this.emit();
    if (!quiet) {
      var t = this.tiers[i];
      var price = i === 0 && this.selfVariant ? this.selfVariant.price : t.price;
      this.say((this.i18n.pieces || [])[t.n] + ' · ' + this.money.format(price));
    }
  };

  proto.retail = function (n) {
    var sum = 0;
    for (var i = 0; i < n; i++) if (this.picks[i]) sum += this.picks[i].price || 0;
    return sum;
  };

  proto.renderTiers = function () {
    var self = this;
    var maxSave = 0;
    this.el.tiers.forEach(function (b) {
      var i = parseInt(b.getAttribute('data-tier'), 10);
      var t = self.tiers[i];
      if (!t) return;
      var on = i === self.tier;
      var ok = self.tierOk(i);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
      b.disabled = !ok && !on;
      var price = b.querySelector('[data-tier-price]');
      var save = b.querySelector('[data-tier-save]');
      var was = b.querySelector('[data-tier-was]');
      var trim = self.priceCut || self.chips;
      if (i === 0) {
        if (price && self.selfVariant) price.textContent = self.money.format(self.selfVariant.price, trim);
        if (save) save.textContent = '';
        return;
      }
      if (price) price.textContent = self.money.format(t.price, trim);
      var full = self.generated && self.picks.slice(0, t.n).every(Boolean);
      var s = full ? self.retail(t.n) - t.price : 0;
      if (save) save.textContent = s > 0 ? tpl(self.i18n.save, { amount: self.money.format(s) }) : '';
      if (s > maxSave) maxSave = s;
      /* price cut mode: the full price of the pieces in the mix, crossed out (only once there's a real saving) */
      if (was) {
        var showWas = self.priceCut && s > 0;
        was.textContent = showWas ? self.money.format(t.price + s, true) : '';
        was.hidden = !showWas;
      }
    });
    /* chips (B11): "Save up to $63" next to the heading, from the biggest saving */
    var upto = this.querySelector ? this.querySelector('[data-rbu-upto]') : null;
    if (upto) {
      upto.textContent = maxSave > 0 ? tpl(upto.getAttribute('data-tpl') || '', { amount: this.money.format(maxSave, true) }) : '';
      upto.hidden = !(maxSave > 0);
    }
  };

  proto.renderPanel = function () {
    var on = this.tier > 0;
    if (this.info && this.info.classList) this.info.classList.toggle('rbu-on', on);
    this.classList.toggle('is-on', on);
    if (this.el.panel) this.el.panel.hidden = !on;
    if (this.el.buy) this.el.buy.hidden = !on;
    if (!on) return;
    var t = this.tiers[this.tier];
    var n = t.n;
    var money = this.money;
    this.renderSlots(n);
    var filled = this.picks.slice(0, n).filter(Boolean).length;
    var complete = filled === n;
    var retail = this.retail(n);
    var saving = complete && retail > t.price ? retail - t.price : 0;
    if (this.el.count) this.el.count.textContent = filled + '/' + n;
    if (this.el.retail) {
      this.el.retail.textContent = money.format(retail);
      this.el.retail.hidden = !saving;
    }
    if (this.el.price) this.el.price.textContent = money.format(t.price);
    if (this.el.pp) this.el.pp.textContent = tpl(this.i18n.perPiece, { price: money.format(Math.round(t.price / n / 100) * 100, true) });
    if (this.el.save) {
      this.el.save.hidden = !saving;
      this.el.save.textContent = saving ? tpl(this.i18n.youSave, { amount: money.format(saving) }) : '';
    }
    if (this.el.shuffle) this.el.shuffle.disabled = !this.generated;
    this.renderCta();
  };

  proto.canChangeSize = function (s) {
    var p = this.byId[s.pid];
    if (!p) return false;
    return p.hasSize && sizeRange(variantsFor(p, s.metalKey || null)).length > 1;
  };

  proto.renderSlots = function (n) {
    var box = this.el.slots;
    if (!box) return;
    var i18n = this.i18n;
    var html = '';
    box.classList.toggle('rbu-slots--many', n > 4);
    for (var i = 0; i < n; i++) {
      var s = this.picks[i];
      if (!s) {
        if (!this.generated) {
          html += '<li class="rbu-slot rbu-slot--skel" aria-hidden="true"><div class="rbu-slot__media"></div><p class="rbu-slot__name"></p><p class="rbu-slot__meta"></p></li>';
        } else {
          html += '<li class="rbu-slot rbu-slot--empty"><div class="rbu-slot__media">' +
            '<button type="button" class="rbu-slot__pick" data-act="swap" data-idx="' + i + '" aria-label="' + esc(tpl(i18n.emptySlot, { number: i + 1 })) + '"><span class="rbu-slot__plus" aria-hidden="true">+</span></button>' +
            '</div><p class="rbu-slot__name">&nbsp;</p><p class="rbu-slot__meta"></p></li>';
        }
        continue;
      }
      var meta;
      if (s.needsSize) {
        meta = '<button type="button" class="rbu-slot__need" data-act="size" data-idx="' + i + '">' + esc(i18n.needsSize) + '</button>';
      } else {
        var bits = [];
        if (s.metal) bits.push(esc(s.metal));
        bits.push(esc(s.size ? tpl(i18n.sizeLabel, { size: s.size }) : i18n.oneSize));
        meta = bits.join(' · ');
      }
      var sizeable = !s.self && this.canChangeSize(s);
      var menu = '';
      if (this.openMenu === i && sizeable) {
        menu = '<div class="rbu-slot__menu">' +
          '<button type="button" data-act="size" data-idx="' + i + '">' + esc(i18n.slotSize) + '</button>' +
          '<button type="button" data-act="swap" data-idx="' + i + '">' + esc(i18n.slotSwap) + '</button></div>';
      }
      var img = s.img ? '<img src="' + esc(imgSize(s.img, 360)) + '" srcset="' + esc(imgSize(s.img, 240)) + ' 240w, ' + esc(imgSize(s.img, 360)) + ' 360w" sizes="(min-width: 1024px) 140px, 30vw" alt="" loading="lazy" width="240" height="300">' : '';
      html += '<li class="rbu-slot is-filled' + (s.needsSize ? ' needs-size' : '') + (s.self ? ' is-self' : '') + (this.newSlot === i || this._popAll ? ' is-new' : '') + '">' +
        '<div class="rbu-slot__media">' +
          '<button type="button" class="rbu-slot__pick" data-act="swap" data-idx="' + i + '" aria-label="' + esc(i18n.swapPiece + ': ' + s.title) + '">' + img + '</button>' +
          (s.self ? '<span class="rbu-slot__flag">' + esc(i18n.thisOne) + '</span>' : '') +
          '<button type="button" class="rbu-slot__edit" data-act="' + (sizeable ? 'menu' : 'swap') + '" data-idx="' + i + '" aria-label="' + esc(tpl(i18n.editPiece, { title: s.title })) + '"' +
            (sizeable ? ' aria-expanded="' + (this.openMenu === i ? 'true' : 'false') + '"' : '') + '>' + PENCIL + '</button>' +
          menu +
        '</div>' +
        '<p class="rbu-slot__name" title="' + esc(s.title) + '">' + esc(s.title) + '</p>' +
        '<p class="rbu-slot__meta">' + meta + '</p>' +
      '</li>';
    }
    box.innerHTML = html;
    this.newSlot = -1;
    this._popAll = false;
  };

  proto.renderCta = function () {
    var cta = this.el.cta;
    if (!cta || this.busy || this.tier === 0) return;
    var t = this.tiers[this.tier];
    var picks = this.picks.slice(0, t.n);
    var empty = picks.filter(function (s) { return !s; }).length;
    var pending = picks.filter(function (s) { return s && s.needsSize; }).length;
    if (empty && !this.generated) { cta.disabled = true; cta.textContent = this.i18n.loading; }
    else if (empty) { cta.disabled = true; cta.textContent = (this.i18n.ctaMore || [])[empty] || ''; }
    else if (!this.tierOk(this.tier)) { cta.disabled = true; cta.textContent = this.i18n.bundleSoldOut; }
    else if (pending) { cta.disabled = false; cta.textContent = tpl(this.i18n.ctaSizes, { count: pending }); }
    else { cta.disabled = false; cta.textContent = (this.i18n.cta || [])[t.n] || ''; }
  };

  proto.toggleMenu = function (i) {
    this.openMenu = this.openMenu === i ? -1 : i;
    this.renderSlots(this.tiers[this.tier] ? this.tiers[this.tier].n : 0);
    var first = this.openMenu > -1 && this.el.slots.children[i] && this.el.slots.children[i].querySelector('.rbu-slot__menu button');
    if (first) first.focus();
  };

  proto.closeMenus = function (quiet) {
    if (this.openMenu < 0) return;
    this.openMenu = -1;
    if (!quiet && this.tier > 0) this.renderSlots(this.tiers[this.tier].n);
  };

  proto.focusSlot = function (i) {
    var li = this.el.slots && this.el.slots.children[i];
    var b = li && li.querySelector('.rbu-slot__pick');
    if (b) { try { b.focus({ preventScroll: true }); } catch (e) { b.focus(); } }
  };

  /* ---------------- "Choose a piece" ---------------- */
  proto.openPicker = function (slot, opener) {
    if (!this.el.picker) return;
    this.closeMenus(true);
    this.pickSlot = slot;
    var s = this.picks[slot];
    var cats = this.cfg.categories || [];
    var c = s && s.cat != null && s.cat > -1 && cats[s.cat] ? s.cat : (this.self.cat > -1 ? this.self.cat : 0);
    this.metal = (s && s.metalKey) || this.prefMetal() || this.cfg.defaultMetal || 'silver';
    this._pickerOpener = opener || document.activeElement;
    this.el.picker.hidden = false;
    this.pickerOpen = true;
    this.lockCheck();
    var picker = this.el.picker;
    picker.classList.remove('is-open');
    void picker.offsetWidth;
    picker.classList.add('is-open');
    this.syncMetalButtons();
    this.selectCategory(c);
    if (this.el.body) this.el.body.scrollTop = 0;
    var close = picker.querySelector('.rbu-picker__hd [data-picker-close]');
    if (close) close.focus();
    this.warm();
  };

  proto.closePicker = function () {
    if (!this.pickerOpen || !this.el.picker) return;
    this.el.picker.hidden = true;
    this.el.picker.classList.remove('is-open');
    this.pickerOpen = false;
    this.lockCheck();
    var back = this._pickerOpener;
    this._pickerOpener = null;
    if (back && document.contains(back) && back.offsetParent !== null) {
      try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); }
    }
  };

  proto.selectCategory = function (index) {
    var cats = this.cfg.categories || [];
    if (!cats[index] || !this.el.grid) return;
    var self = this;
    this.cat = index;
    this.sub = '';
    if (this.el.cats) {
      toArray(this.el.cats.querySelectorAll('[data-cat]')).forEach(function (b) {
        var on = parseInt(b.getAttribute('data-cat'), 10) === index;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.setAttribute('tabindex', on ? '0' : '-1');
        var box = b.parentNode;
        if (on && box.scrollWidth > box.clientWidth) {
          /* only scroll when the chosen tab is cut off, so the first tabs stay in view */
          var l = b.offsetLeft, r = l + b.offsetWidth;
          if (l < box.scrollLeft) box.scrollLeft = Math.max(0, l - 14);
          else if (r > box.scrollLeft + box.clientWidth) box.scrollLeft = r - box.clientWidth + 14;
        }
      });
    }
    var entry = this.products[index];
    if (entry && entry.first) {
      this.renderSubs();
      this.renderGrid();
      this.loadRest(index);
      return;
    }
    this.el.grid.setAttribute('aria-busy', 'true');
    this.el.grid.innerHTML = this.skeleton();
    this.setStatus('');
    if (this.el.subs) this.el.subs.hidden = true;
    if (this.el.metalToggle) this.el.metalToggle.hidden = true;
    this.renderMeta();
    this.ensureCategory(index).then(function () {
      if (self.cat !== index || !self.pickerOpen) return;
      self.renderSubs();
      self.renderGrid();
      self.loadRest(index);
    }).catch(function () {
      if (self.cat !== index) return;
      self.el.grid.setAttribute('aria-busy', 'false');
      self.el.grid.innerHTML = '';
      self.setStatus(self.i18n.loadError);
      self.renderMeta();
    });
  };

  proto.skeleton = function () {
    var html = '';
    for (var i = 0; i < 6; i++) html += '<div class="rbu-card rbu-card--skel" aria-hidden="true"><div class="rbu-card__media"></div><div class="rbu-card__body"><span></span><span></span></div></div>';
    return html;
  };

  proto.matchesSub = function (p, tag) {
    if (!tag) return true;
    var t = tag.toLowerCase();
    if (p.tags.indexOf(t) > -1) return true;
    return (' ' + p.title.toLowerCase() + ' ').indexOf(' ' + t) > -1;
  };

  proto.renderSubs = function () {
    var box = this.el.subs;
    var cat = (this.cfg.categories || [])[this.cat];
    var entry = this.products[this.cat];
    if (!box || !cat || !entry) return;
    var self = this;
    var filters = (cat.filters || []).filter(function (f) {
      return entry.list.some(function (p) { return self.isPiece(p) && self.matchesSub(p, f.tag); });
    });
    if (!filters.length) { box.hidden = true; box.innerHTML = ''; return; }
    var html = '<button type="button" role="tab" class="rbu-sub" data-sub="" aria-selected="' + (self.sub ? 'false' : 'true') + '" tabindex="' + (self.sub ? '-1' : '0') + '">' + esc(this.i18n.all) + '</button>';
    filters.forEach(function (f) {
      var on = self.sub === f.tag;
      html += '<button type="button" role="tab" class="rbu-sub" data-sub="' + esc(f.tag) + '" aria-selected="' + on + '" tabindex="' + (on ? '0' : '-1') + '">' + esc(f.label) + '</button>';
    });
    box.innerHTML = html;
    box.hidden = false;
  };

  proto.selectSub = function (tag) {
    this.sub = tag || '';
    var self = this;
    toArray(this.el.subs.querySelectorAll('[data-sub]')).forEach(function (b) {
      var on = b.getAttribute('data-sub') === self.sub;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.setAttribute('tabindex', on ? '0' : '-1');
    });
    this.renderGrid();
  };

  proto.syncMetalButtons = function () {
    var self = this;
    if (!this.el.metalToggle) return;
    toArray(this.el.metalToggle.querySelectorAll('[data-metal]')).forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-metal') === self.metal ? 'true' : 'false');
    });
  };

  proto.soldOut = function (p) {
    if (!p.available) return true;
    return !variantsFor(p, this.metal).some(avail);
  };

  proto.visibleProducts = function () {
    var entry = this.products[this.cat];
    if (!entry) return [];
    var self = this;
    var list = entry.list.filter(function (p) {
      if (!self.isPiece(p) || !self.matchesSub(p, self.sub)) return false;
      if (p.hasMetal && !p.metals[self.metal]) return false;
      return true;
    });
    var ok = [], out = [];
    list.forEach(function (p) { (self.soldOut(p) ? out : ok).push(p); });
    return ok.concat(out);
  };

  proto.renderMeta = function () {
    if (!this.el.meta) return;
    var entry = this.products[this.cat];
    if (!entry || !entry.first) { this.el.meta.textContent = this.i18n.loading; return; }
    var self = this;
    var t = this.tiers[this.tier];
    var total = t && this.tier > 0 ? t.n : this.maxN;
    var count = this.visibleProducts().filter(function (p) { return !self.soldOut(p); }).length;
    this.el.meta.textContent = tpl(this.i18n.chooseMeta, { number: this.pickSlot + 1, total: total, pieces: count });
  };

  proto.setStatus = function (text) {
    if (!this.el.status) return;
    this.el.status.textContent = text || '';
    this.el.status.hidden = !text;
  };

  proto.renderGrid = function () {
    var grid = this.el.grid;
    var entry = this.products[this.cat];
    if (!grid || !entry) return;
    var self = this;
    var hasMetals = entry.list.some(function (p) { return p.hasMetal; });
    if (this.el.metalToggle) this.el.metalToggle.hidden = !hasMetals;
    var list = this.visibleProducts();
    grid.setAttribute('aria-busy', 'false');
    grid.innerHTML = list.map(function (p) { return self.cardHtml(p); }).join('');
    if (!list.length) {
      var label = this.metal === 'gold' ? this.i18n.metalGold : this.i18n.metalSilver;
      this.setStatus(hasMetals ? tpl(this.i18n.noMetal, { metal: label }) : this.i18n.empty);
    } else {
      this.setStatus('');
    }
    this.renderMeta();
  };

  proto.cardHtml = function (p) {
    var i18n = this.i18n;
    var list = variantsFor(p, this.metal);
    var sizes = sizeRange(list);
    var soldOut = this.soldOut(p);
    var cur = this.picks[this.pickSlot];
    var isCur = !!(cur && same(cur.pid, p.id));
    var t = this.tiers[this.tier];
    var n = t && this.tier > 0 ? t.n : this.maxN;
    var inBundle = 0;
    for (var i = 0; i < n; i++) if (this.picks[i] && same(this.picks[i].pid, p.id)) inBundle++;
    var imgs = imagesFor(p, this.metal);
    var price = lowestPrice(list.filter(avail).length ? list.filter(avail) : list);
    var sizeText = sizes.length > 1 ? tpl(i18n.sizesRange, { range: sizes[0] + '–' + sizes[sizes.length - 1] }) : i18n.oneSize;
    var title = esc(p.title);
    var pics = imgs.filter(Boolean).map(function (src, k) {
      return '<img src="' + esc(imgSize(src, 360)) + '" srcset="' + esc(imgSize(src, 240)) + ' 240w, ' + esc(imgSize(src, 360)) + ' 360w, ' + esc(imgSize(src, 540)) + ' 540w" sizes="(min-width: 768px) 180px, 33vw" alt="' + (k ? '' : title) + '" loading="lazy" width="360" height="450">';
    });
    var dots = pics.length > 1 ? '<span class="rbu-card__dots" aria-hidden="true"><i class="is-on"></i><i></i></span>' : '';
    var flag = soldOut ? '<span class="rbu-card__flag">' + esc(i18n.soldOut) + '</span>' : (inBundle ? '<span class="rbu-card__flag">' + esc(isCur ? i18n.inBundle : i18n.inBundle) + '</span>' : '');
    var label = isCur ? i18n.inBundle : i18n.swapIn;
    return '<div class="rbu-card' + (soldOut ? ' is-soldout' : '') + (inBundle ? ' is-in' : '') + (isCur ? ' is-current' : '') + '" role="listitem" data-pid="' + esc(p.id) + '">' +
      '<div class="rbu-card__media" data-pick>' +
        '<div class="rbu-card__track">' + pics.join('') + '</div>' + dots + flag +
        (soldOut ? '' : '<button type="button" class="rbu-card__plus" data-pick aria-label="' + esc(label + ': ' + p.title) + '">' + PLUS + '</button>') +
      '</div>' +
      '<div class="rbu-card__body">' +
        '<span class="rbu-card__name" title="' + title + '">' + title + '</span>' +
        '<span class="rbu-card__meta">' + esc(sizeText) + '</span>' +
        (price ? '<span class="rbu-card__price"><s>' + esc(this.money.format(price, true)) + '</s></span>' : '') +
      '</div>' +
    '</div>';
  };

  proto.hoverSwap = function (e, enter) {
    // html.ry-mouse = a real mouse on a PC that Chrome reports as touch-only (layout/theme.liquid)
    if (!hoverMq.matches && !document.documentElement.classList.contains('ry-mouse')) return;
    var media = e.target.closest && e.target.closest('.rbu-card__media');
    if (!media || (e.relatedTarget && media.contains(e.relatedTarget))) return;
    var track = media.querySelector('.rbu-card__track');
    if (!track || track.children.length < 2) return;
    track.scrollTo({ left: enter ? track.clientWidth : 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  };

  proto.choosePiece = function (pid, opener) {
    var p = this.byId[pid];
    var slot = this.pickSlot;
    if (!p || slot < 0) return;
    if (same(p.id, this.self.id)) { this.place(slot, this.selfPiece()); return; }
    var all = variantsFor(p, this.metal);
    var list = all.filter(avail);
    if (!list.length) { all = p.variants; list = all.filter(avail); }
    if (!list.length) return;
    var cur = this.picks[slot];
    if (p.hasSize && sizeRange(all).length > 1) {
      var want = cur && same(cur.pid, p.id) && cur.size ? cur.size : this.selfSize();
      var has = want != null && all.some(function (v) { return v.available && String(v.size) === String(want); });
      this.openSizeModal(p, { slot: slot, variants: all, current: has ? String(want) : null, opener: opener, update: false });
      return;
    }
    if (cur && same(cur.pid, p.id) && !cur.needsSize) { this.closePicker(); return; }
    this.place(slot, this.pieceFrom(p, list[0]));
  };

  proto.place = function (slot, piece) {
    if (!piece) return;
    var old = this.picks[slot];
    piece.user = !piece.self;
    this.picks[slot] = piece;
    this.newSlot = slot;
    this.closePicker();
    this.renderPanel();
    this.renderTiers();
    this.emit();
    this.say(old && !same(old.pid, piece.pid) ? tpl(this.i18n.swapped, { title: old.title }) : tpl(this.i18n.addedToBundle, { title: piece.title }));
    this.focusSlot(slot);
  };

  /* ---------------- size pop-up ---------------- */
  proto.openSizeFor = function (i, opener) {
    var s = this.picks[i];
    if (!s || s.self) return;
    var p = this.byId[s.pid];
    if (!p) return;
    this.openSizeModal(p, { slot: i, variants: variantsFor(p, s.metalKey || null), current: s.needsSize ? null : s.size, opener: opener, update: true });
  };

  proto.openSizeModal = function (p, ctx) {
    var modal = this.el.size;
    if (!modal) return;
    this.sizeCtx = ctx;
    ctx.product = p;
    ctx.vid = null;
    var img = modal.querySelector('[data-szp-img]');
    var first = ctx.variants.filter(function (v) { return v.image; })[0];
    var src = first ? first.image : (p.images[0] || '');
    if (img) { img.src = imgSize(src, 160); img.alt = ''; }
    var name = modal.querySelector('[data-szp-name]');
    if (name) name.textContent = p.title;
    var sizes = modal.querySelector('[data-szp-sizes]');
    var self = this;
    var html = '';
    var seen = {};
    ctx.variants.forEach(function (v) {
      if (!v.size || seen[v.size]) return;
      seen[v.size] = 1;
      var on = ctx.current && v.size === ctx.current && v.available;
      if (on) ctx.vid = String(v.id);
      html += '<button type="button" role="radio" aria-checked="' + (on ? 'true' : 'false') + '" data-size-vid="' + esc(v.id) + '"' +
        (v.available ? '' : ' disabled aria-label="' + esc(v.size + ' – ' + self.i18n.sizeSoldOut) + '"') + '>' + esc(v.size) + '</button>';
    });
    sizes.innerHTML = html;
    var guide = modal.querySelector('[data-szp-guide]');
    if (guide) {
      var keys = Object.keys(seen);
      var numeric = keys.length > 0 && keys.every(function (s) { return /^\d+([.,]\d+)?$/.test(String(s).trim()); });
      guide.hidden = !(numeric && this.guide && this.guide.chart.length);
      guide.textContent = this.i18n.ringGuide;
    }
    this.syncSizeSave();
    this.showModal(modal, ctx.opener);
    var focus = sizes.querySelector('[aria-checked="true"]') || sizes.querySelector('button:not(:disabled)');
    if (focus) focus.focus();
  };

  proto.chooseSize = function (vid) {
    if (!this.sizeCtx || !this.el.size) return;
    this.sizeCtx.vid = String(vid);
    toArray(this.el.size.querySelectorAll('[data-szp-sizes] [data-size-vid]')).forEach(function (b) {
      b.setAttribute('aria-checked', b.getAttribute('data-size-vid') === String(vid) ? 'true' : 'false');
    });
    this.syncSizeSave();
  };

  proto.syncSizeSave = function () {
    var save = this.el.size && this.el.size.querySelector('[data-szp-save]');
    var ctx = this.sizeCtx;
    if (!save || !ctx) return;
    var v = null;
    ctx.variants.forEach(function (x) { if (String(x.id) === ctx.vid) v = x; });
    save.disabled = !v;
    save.textContent = v ? tpl(ctx.update ? this.i18n.sizeSave : this.i18n.sizeAdd, { size: v.size }) : this.i18n.chooseSize;
  };

  proto.saveSize = function () {
    var ctx = this.sizeCtx;
    if (!ctx || !ctx.vid) return;
    var v = null;
    ctx.variants.forEach(function (x) { if (String(x.id) === ctx.vid) v = x; });
    if (!v) return;
    this.sizeCtx = null;
    ctx.opener = null;
    this.closeModal(this.el.size);
    var s = this.picks[ctx.slot];
    if (ctx.update && s && same(s.pid, ctx.product.id)) {
      s.vid = v.id; s.size = v.size; s.sku = v.sku || ''; s.price = v.price; s.needsSize = false; s.inherit = false; s.user = true;
      if (v.image) s.img = v.image;
      this.newSlot = ctx.slot;
      this.renderPanel();
      this.renderTiers();
      this.emit();
      this.say(tpl(this.i18n.sizeLabel, { size: v.size }) + ' · ' + s.title);
      this.focusSlot(ctx.slot);
    } else {
      this.place(ctx.slot, this.pieceFrom(ctx.product, v));
    }
  };

  /* ---------------- ring size guide (same as the bundle page) ---------------- */
  proto.openGuide = function (btn) {
    if (!this.guide) return;
    this.updateGuideBack();
    this.showModal(this.guide.modal, btn);
  };

  proto.initGuide = function () {
    var modal = this.el.guide;
    if (!modal) return;
    var self = this;
    this.guide = { modal: modal, mode: 'ring', unit: 'mm', chart: parseChart(this.cfg.guideChart), pick: null, vid: null };
    if (!this.guide.chart.length) this.guide.chart = parseChart('8=48;10=50;12=52;14=54;16=56;18=58;20=60;22=62;24=64');
    this.guide.input = modal.querySelector('[data-calc-input]');
    modal.addEventListener('click', function (e) {
      var m = e.target.closest('[data-guide-mode]');
      if (m) { self.setGuideMode(m.getAttribute('data-guide-mode')); return; }
      var u = e.target.closest('[data-guide-unit]');
      if (u) { self.setGuideUnit(u.getAttribute('data-guide-unit')); return; }
      if (e.target.closest('[data-guide-back]')) self.guideBack();
    });
    if (this.guide.input) this.guide.input.addEventListener('input', function () { self.calcGuide(); });
    this.renderGuide();
  };

  proto.guideFmt = function (mm, unit) {
    if (unit === 'in') return (mm / 25.4).toFixed(2);
    return (Math.round(mm * 10) / 10).toFixed(1).replace(/\.0$/, '');
  };

  proto.guideValue = function (row, mode) { return mode === 'finger' ? row.c : row.c / Math.PI; };

  proto.setGuideMode = function (mode) {
    if (!this.guide || this.guide.mode === mode) return;
    this.guide.mode = mode;
    if (this.guide.input) this.guide.input.value = '';
    this.renderGuide();
  };

  proto.setGuideUnit = function (unit) {
    var g = this.guide;
    if (!g || g.unit === unit) return;
    var v = g.input ? parseFloat(String(g.input.value).replace(',', '.')) : NaN;
    if (v > 0) g.input.value = unit === 'in' ? (v / 25.4).toFixed(2) : (v * 25.4).toFixed(1);
    g.unit = unit;
    this.renderGuide();
  };

  proto.renderGuide = function () {
    var g = this.guide;
    if (!g) return;
    var self = this;
    var modal = g.modal;
    var unitLabel = g.unit === 'in' ? this.i18n.gIn : this.i18n.gMm;
    toArray(modal.querySelectorAll('[data-guide-mode]')).forEach(function (b) {
      var on = b.getAttribute('data-guide-mode') === g.mode;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.setAttribute('tabindex', on ? '0' : '-1');
    });
    toArray(modal.querySelectorAll('[data-guide-show]')).forEach(function (el) {
      if (el.getAttribute('data-guide-show') === g.mode) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    toArray(modal.querySelectorAll('[data-guide-unit]')).forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-guide-unit') === g.unit ? 'true' : 'false');
    });
    var label = tpl(g.mode === 'finger' ? this.i18n.gCircumference : this.i18n.gDiameter, { unit: unitLabel });
    var lab = modal.querySelector('[data-calc-label]');
    if (lab) lab.textContent = label;
    var col = modal.querySelector('[data-table-col]');
    if (col) col.textContent = label;
    var unitEl = modal.querySelector('[data-calc-unit]');
    if (unitEl) unitEl.textContent = unitLabel;
    var mid = g.chart[Math.floor((g.chart.length - 1) / 2)] || { c: 56 };
    if (g.input) g.input.placeholder = tpl(this.i18n.gExample, { value: this.guideFmt(this.guideValue(mid, g.mode), g.unit) });
    var body = modal.querySelector('[data-table-body]');
    if (body) {
      body.innerHTML = g.chart.map(function (r) {
        return '<tr' + (g.pick === r.size ? ' class="is-match"' : '') + '><td>' + esc(self.guideFmt(self.guideValue(r, g.mode), g.unit)) + '</td><td>' + esc(r.size) + '</td></tr>';
      }).join('');
    }
    this.calcGuide();
  };

  proto.calcGuide = function () {
    var g = this.guide;
    if (!g || !g.input) return;
    var out = g.modal.querySelector('[data-calc-result]');
    var raw = String(g.input.value).replace(',', '.').trim();
    var v = parseFloat(raw);
    var text = '—';
    g.pick = null;
    if (raw && v > 0) {
      var mm = g.unit === 'in' ? v * 25.4 : v;
      var c = g.mode === 'finger' ? mm : mm * Math.PI;
      var first = g.chart[0], last = g.chart[g.chart.length - 1];
      var step = g.chart.length > 1 ? g.chart[1].c - first.c : 2;
      var tol = 0.5;
      if (c < first.c - step) text = tpl(this.i18n.gSmaller, { size: first.size });
      else if (c > last.c + tol) text = tpl(this.i18n.gLarger, { size: last.size });
      else {
        for (var i = 0; i < g.chart.length; i++) {
          if (g.chart[i].c >= c - tol) { g.pick = g.chart[i].size; break; }
        }
        text = g.pick || '—';
      }
    }
    if (out) out.textContent = text;
    toArray(g.modal.querySelectorAll('[data-table-body] tr')).forEach(function (tr, i) {
      tr.classList.toggle('is-match', !!g.pick && g.chart[i] && g.chart[i].size === g.pick);
    });
    this.updateGuideBack();
  };

  proto.updateGuideBack = function () {
    var g = this.guide;
    if (!g) return;
    var back = g.modal.querySelector('[data-guide-back]');
    var ctx = this.sizeCtx;
    g.vid = null;
    if (g.pick && ctx && ctx.variants) {
      var chartSizes = g.chart.map(function (r) { return r.size; });
      var sized = ctx.variants.filter(function (v) { return v.size; });
      var allInChart = sized.length > 0 && sized.every(function (v) { return chartSizes.indexOf(String(v.size).trim()) > -1; });
      if (allInChart) {
        sized.forEach(function (v) { if (!g.vid && v.available && String(v.size).trim() === g.pick) g.vid = String(v.id); });
      }
    }
    if (back) back.textContent = g.vid ? tpl(this.i18n.gUseSize, { size: g.pick }) : this.i18n.backToSizes;
  };

  proto.guideBack = function () {
    var g = this.guide;
    var vid = g && g.vid;
    this.closeModal(g.modal);
    if (vid && this.sizeCtx) {
      this.chooseSize(vid);
      var save = this.el.size && this.el.size.querySelector('[data-szp-save]');
      if (save) save.focus();
    }
  };

  /* ---------------- modals ---------------- */
  proto.showModal = function (modal, opener) {
    if (!modal) return;
    if (this.modalStack.indexOf(modal) < 0) this.modalStack.push(modal);
    modal._opener = opener || document.activeElement;
    modal.hidden = false;
    this.lockCheck();
    var panel = modal.querySelector('.rbu-modal__panel');
    if (panel && !panel.contains(document.activeElement)) {
      var f = panel.querySelector('button:not(:disabled), [href], [tabindex]:not([tabindex="-1"])');
      if (f) f.focus();
    }
  };

  proto.closeModal = function (modal) {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    this.modalStack = this.modalStack.filter(function (m) { return m !== modal; });
    this.lockCheck();
    if (modal === this.el.size) this.sizeCtx = null;
    var back = modal._opener;
    modal._opener = null;
    if (back && document.contains(back) && back.focus && back.offsetParent !== null) back.focus();
  };

  proto.lockCheck = function () {
    document.body.classList.toggle('rbu-lock', this.pickerOpen || this.modalStack.length > 0);
  };

  proto.trapFocus = function (e, box) {
    var f = toArray(box.querySelectorAll('button:not(:disabled), a[href], input, [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!box.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  };

  /* ---------------- add to cart ---------------- */
  proto.checkout = function (trigger) {
    if (this.busy || this.tier === 0) return;
    var t = this.tiers[this.tier];
    var picks = this.picks.slice(0, t.n);
    var i;
    if (!this.generated && picks.some(function (s) { return !s; })) { this.warm(); return; }
    for (i = 0; i < picks.length; i++) if (!picks[i]) { this.openPicker(i, trigger); return; }
    for (i = 0; i < picks.length; i++) if (picks[i].needsSize) { this.openSizeFor(i, trigger); return; }
    if (!this.tierOk(this.tier)) { this.flash(this.i18n.bundleSoldOut, 'error'); return; }
    var dupes = this.duplicates(picks);
    if (dupes.length && this.el.dupes) {
      var list = this.el.dupes.querySelector('[data-dupe-list]');
      if (list) list.innerHTML = dupes.map(function (d) { return '<li>' + esc(d.title) + ' ×' + d.count + '</li>'; }).join('');
      this._pending = trigger;
      this.showModal(this.el.dupes, trigger);
      return;
    }
    this.addToCart(trigger);
  };

  proto.duplicates = function (picks) {
    var seen = {}, out = [];
    picks.forEach(function (s) {
      var key = String(s.vid);
      if (!seen[key]) { seen[key] = { title: s.title + (s.size ? ' · ' + s.size : ''), count: 0 }; }
      seen[key].count++;
    });
    Object.keys(seen).forEach(function (k) { if (seen[k].count > 1) out.push(seen[k]); });
    return out;
  };

  proto.cartItems = function () {
    var t = this.tiers[this.tier];
    var n = t.n;
    var props = {};
    for (var i = 0; i < n; i++) {
      var s = this.picks[i];
      var num = i + 1;
      var bits = [s.title];
      if (s.metal) bits.push(s.metal);
      if (s.size) bits.push('Size ' + s.size);
      props['Piece ' + num] = bits.join(' · ');
      props['_p' + num] = [s.handle, s.vid, s.metal || '', s.size || ''].join('|');
    }
    props._bundle = '1';
    props._bundle_count = String(n);
    return [{ id: Number(t.variantId) || t.variantId, quantity: 1, properties: props }];
  };

  proto.setBusy = function (on, trigger) {
    var self = this;
    this.busy = on;
    var btns = [this.el.cta];
    if (trigger && btns.indexOf(trigger) < 0) btns.push(trigger);
    if (on) this._busyBtns = btns;
    (on ? btns : (this._busyBtns || btns)).forEach(function (b) {
      if (!b) return;
      if (on) {
        if (!b.hasAttribute('data-rbu-label')) b.setAttribute('data-rbu-label', b.textContent);
        b.textContent = self.i18n.adding;
        b.disabled = true;
      } else {
        if (b.hasAttribute('data-rbu-label')) { b.textContent = b.getAttribute('data-rbu-label'); b.removeAttribute('data-rbu-label'); }
        b.disabled = false;
      }
    });
    if (!on) {
      this._busyBtns = null;
      this.renderCta();
      this.emit();
    }
  };

  proto.addToCart = function (trigger) {
    var self = this;
    if (this.busy) return;
    this.setBusy(true, trigger);
    this.flash('');
    fetch(this.cfg.cartAddUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: this.cartItems() })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || self.i18n.addFailed);
        return data;
      });
    }).then(function () {
      self.onAdded();
    }).catch(function (err) {
      self.setBusy(false);
      self.flash((err && err.message) || self.i18n.addFailed, 'error');
    });
  };

  proto.onAdded = function () {
    var t = this.tiers[this.tier];
    try {
      document.dispatchEvent(new CustomEvent('rynor:bundle-added', { detail: { bundle: t.handle, pieces: t.n, from: 'product' } }));
    } catch (e) {}
    this.setBusy(false);
    this.flash(this.i18n.bundleAdded, 'ok');
    this.say(this.i18n.bundleAdded);
    var tc = themeCartConfig();
    if (!hasThemeCart() || /page/.test(String(tc.cart_action || ''))) {
      window.location.assign(this.cfg.cartUrl);
      return;
    }
    openThemeCart();
  };

  /* ---------------- messages ---------------- */
  proto.flash = function (text, kind) {
    var m = this.el.msg;
    if (!m) return;
    clearTimeout(this._flashT);
    m.textContent = text || '';
    m.classList.toggle('is-error', kind === 'error');
    m.classList.toggle('is-ok', kind === 'ok');
    if (text && kind !== 'error') {
      this._flashT = setTimeout(function () { m.textContent = ''; m.classList.remove('is-ok'); }, 4000);
    }
  };

  proto.say = function (text) {
    var live = this.el.live;
    if (!live || !text) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 40);
  };

  proto.emit = function () {
    var t = this.tiers[this.tier];
    try {
      document.dispatchEvent(new CustomEvent('rynor:bundle-change', {
        detail: { productId: this.cfg.productId, pieces: this.tier > 0 && t ? t.n : 1 }
      }));
    } catch (e) {}
  };

  /* ---------------- for the sticky bar ---------------- */
  proto.isBundleActive = function () { return !!this._ready && this.tier > 0; };

  proto.stickyLabel = function () {
    var t = this.tiers[this.tier];
    if (!t || this.tier === 0) return '';
    if (this.busy) return this.i18n.adding;
    return tpl(this.i18n.stickyCta, { number: t.n, price: this.money.format(t.price) });
  };

  proto.stickyAdd = function (btn) { this.checkout(btn || this.el.cta); };

  window.customElements.define('rynor-bundle-upsell', RynorBundleUpsell);
})();
